
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyer-guide",
      function () {
        return require("private-next-pages/buyer-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyer-guide"])
      });
    }
  